import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'
import FileForUserKeys from '../../constants/locale/key/FileForUser'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )
  let maxLengthErrorMessage = translate(
    Namespace.FILE_FOR_USER,
    FileForUserKeys.Validations.ERROR_MSG_MAX_LENGTH
  )

  return Yup.object({
    username: Yup.string().max(50,maxLengthErrorMessage+" 50").required(requiredMessage).nullable(),
  })
}

export default makeValidationSchema
